import { render, staticRenderFns } from "./TalkThread.vue?vue&type=template&id=efcb19b0&"
import script from "./TalkThread.vue?vue&type=script&lang=ts&"
export * from "./TalkThread.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports